import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Download, Package, FileText } from "lucide-react";

export default function DownloadPage() {
  const handleDownload = () => {
    window.location.href = '/api/download/package';
  };

  return (
    <div className="container mx-auto py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <Package className="h-16 w-16 mx-auto mb-4 text-purple-600" />
          <h1 className="text-3xl font-bold">Download PCI Scan Report</h1>
          <p className="text-muted-foreground mt-2">
            Get the complete PCI Scan Report package for laptop deployment
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Download className="h-5 w-5" />
              Lightweight Package (167MB)
            </CardTitle>
            <CardDescription>
              Optimized package close to your 150MB target. Requires npm install after extraction.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <span className="font-medium">Size:</span> 167MB
              </div>
              <div>
                <span className="font-medium">Setup:</span> npm install required
              </div>
              <div>
                <span className="font-medium">Includes:</span> All latest fixes
              </div>
              <div>
                <span className="font-medium">Database:</span> SQLite ready
              </div>
            </div>

            <div className="bg-muted p-4 rounded-lg">
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <FileText className="h-4 w-4" />
                What's Included:
              </h4>
              <ul className="text-sm space-y-1 text-muted-foreground">
                <li>✅ Fixed sidebar navigation</li>
                <li>✅ Working "Start New Scan" button</li>
                <li>✅ Complete source code</li>
                <li>✅ Setup scripts for SQLite and PostgreSQL</li>
                <li>✅ All latest bug fixes and improvements</li>
              </ul>
            </div>

            <Button 
              onClick={handleDownload}
              className="w-full"
              size="lg"
              data-testid="button-download-package"
            >
              <Download className="h-5 w-5 mr-2" />
              Download Package (167MB)
            </Button>

            <div className="text-xs text-muted-foreground text-center">
              After download, extract and run: npm install, then ./laptop-start-sqlite.sh
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}